import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

import { useDispatch, useSelector } from 'react-redux';
import usePortal from 'react-useportal';
import {
  CupGroupTable,
  QualifiersTable,
  CupGroupTableMobile,
} from '../../components/DomesticCup';
import LeagueCup from '../../components/LeagueCup';
import LeagueCalendar from '../../components/LeagueCalendar';
import FallbackContentAnimation from '../../components/FallbackContentAnimation';
import {
  UpcomingCalendarPreloader,
  CupSidePreloader,
  WinnerPreloader,
  PlayingPreloader,
  MobileCupGroupPreloader,
} from '../../components/ContentPreloaders';
import { TeamInfoPopup } from '../../components/Popup';

import {
  domesticCupRequest,
  domesticCupLeaguesRequest,
} from '../../redux/actions/DomesticCup';
import {
  leagueGetLeagueTableData,
  getLeaguesList,
} from '../../redux/actions/League';

import { getLeagueId } from '../../redux/selector/League';
import {
  domesticCupInfo,
  domesticDataLoading,
  domesticCupCalendar,
} from '../../redux/selector/DomesticCup';
import { getPopupByName } from '../../redux/selector/Popups';

import {
  StyledWrapperContainer,
  StyledCupGrid,
  StyledBracketColumn,
  StyledCalendarColumn,
  StyledBracketCard,
  StyledGroupMatch,
  StyledMobileLeague,
  StyledPlayingSectionPreloader,
  StyledSectionPreloader,
  StyledBracketPreloader,
} from './styled';
import { POPUPS } from '../../service/constants';

const DomesticCup = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(domesticDataLoading);
  const data = useSelector(domesticCupInfo);
  const calendarDate = useSelector(domesticCupCalendar);
  const leagueId = useSelector(getLeagueId);
  const { TEAM_INFO_POPUP } = POPUPS;
  const teamInfoPopupData = useSelector(getPopupByName(TEAM_INFO_POPUP));
  const hasCupData = typeof data.phase === 'number';
  const hasCalendar =
    Array.isArray(calendarDate) && calendarDate.length > 0;
  const heroLoading = isLoading && !hasCupData;
  const calendarLoading = !hasCalendar;
  const bracketLoading = !hasCupData;

  useEffect(() => {
    dispatch(getLeaguesList());
    if (data.phase == null) {
      dispatch(domesticCupRequest());
    }
    if (!leagueId) {
      dispatch(leagueGetLeagueTableData());
    }
  }, [dispatch, data.phase, leagueId]);

  useEffect(() => {
    if (leagueId) {
      dispatch(domesticCupLeaguesRequest(leagueId));
    }
  }, [leagueId, dispatch]);

  const { Portal } = usePortal({
    bindTo: document && document.querySelector('#modal'),
  });

  return (
    <StyledWrapperContainer>
      {!isEmpty(teamInfoPopupData) && (
        <Portal>
          <TeamInfoPopup popupName={TEAM_INFO_POPUP} />
        </Portal>
      )}
      <FallbackContentAnimation
        loading={heroLoading}
        fallback={
          <StyledPlayingSectionPreloader>
            <PlayingPreloader style={{ width: '100%', height: '100%' }} />
          </StyledPlayingSectionPreloader>
        }
      >
        <LeagueCup phase={data.phase} leagueId={leagueId} />
      </FallbackContentAnimation>
      <StyledCupGrid>
        <StyledBracketColumn>
          <FallbackContentAnimation
            loading={bracketLoading}
            fallback={
              <StyledBracketPreloader>
                <CupSidePreloader />
                <WinnerPreloader />
                <CupSidePreloader rtl />
              </StyledBracketPreloader>
            }
          >
            <StyledBracketCard>
              <StyledGroupMatch>
                {data.phase === 0 ? <QualifiersTable /> : <CupGroupTable />}
              </StyledGroupMatch>
            </StyledBracketCard>
          </FallbackContentAnimation>
          <FallbackContentAnimation
            loading={bracketLoading || calendarLoading}
            fallback={
              <StyledMobileLeague>
                <MobileCupGroupPreloader />
              </StyledMobileLeague>
            }
          >
            <StyledMobileLeague>
              <CupGroupTableMobile
                calendar={calendarDate}
                phase={data.phase}
              />
            </StyledMobileLeague>
          </FallbackContentAnimation>
        </StyledBracketColumn>
        <StyledCalendarColumn>
          <FallbackContentAnimation
            loading={calendarLoading}
            fallback={
              <StyledSectionPreloader>
                <UpcomingCalendarPreloader />
              </StyledSectionPreloader>
            }
          >
            <LeagueCalendar calendar={calendarDate} phase={data.phase} />
          </FallbackContentAnimation>
        </StyledCalendarColumn>
      </StyledCupGrid>
    </StyledWrapperContainer>
  );
};
export default DomesticCup;
